<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <div
    class="access-opinion-skeleton"
    role="status"
    aria-busy="true"
    :aria-label="t('formalization.electricity_bill.access_opinion.loading')"
    data-testid="access-opinion-skeleton"
  >
    <div class="skeleton-alert skeleton-shimmer" />
    <div class="skeleton-label skeleton-shimmer" />
    <div class="skeleton-upload skeleton-shimmer" />
  </div>
</template>

<style scoped lang="scss">
.access-opinion-skeleton {
  @apply flex flex-col items-start gap-4 w-full rounded-lg bg-neutral-high-light p-4;

  > .skeleton-alert {
    @apply w-full h-[96px] rounded-md;
  }

  > .skeleton-label {
    @apply h-[14px] w-[200px] rounded-[4px];
  }

  > .skeleton-upload {
    @apply w-full h-[72px] rounded-md;
  }
}

.skeleton-shimmer {
  @apply relative overflow-hidden bg-neutral-high-medium;

  &::after {
    @apply absolute inset-0 w-full h-full;
    content: '';
    background: linear-gradient(
      90deg,
      transparent 0%,
      theme('colors.neutral.high.light') 50%,
      transparent 100%
    );
    animation: shimmer 1.5s infinite;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
